// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"22af9042","598":"b3505b2f","703":"310f9ffa"}[chunkId] + ".chunk.js";
};